// extracted by mini-css-extract-plugin
export default {"container":"CardItem_container__+A6FH","background":"CardItem_background__NmDx7","active":"CardItem_active__zB6S1","small":"CardItem_small__+r-+1"};